import getConfig from 'next/config'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Breakpoints } from '@src/utils/useResponsiveSizes'
import { useRouter } from '@src/routes'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

export function useShoppingAi() {
  const theme = useTheme()
  const router = useRouter()
  const { country, language } = router.query
  const isEnUs = country === 'US' && language === 'en'
  const isMobile = useMediaQuery(theme.breakpoints.down(Breakpoints.MD), {
    defaultMatches: true,
  })

  return !!featureFlags.shoppingAi && isEnUs && !isMobile
}
